import { datadogEnabled } from '../config';
import { reportError } from './telemetry';

type Attrs = Record<string, unknown>;

/** Structured console logger; errors are also forwarded to Datadog RUM when it is enabled. */
export class Logger {
  constructor(private readonly name: string) {}

  debug(message: string, attrs?: Attrs) {
    if (import.meta.env.DEV) this.write('debug', message, attrs);
  }
  info(message: string, attrs?: Attrs) {
    this.write('info', message, attrs);
  }
  warn(message: string, attrs?: Attrs & { error?: unknown }) {
    this.write('warn', message, attrs);
  }
  error(message: string, attrs?: Attrs & { error?: unknown }) {
    this.write('error', message, attrs);
    if (datadogEnabled && attrs?.error) {
      reportError(attrs.error, { logger: this.name, message });
    }
  }

  private write(level: 'debug' | 'info' | 'warn' | 'error', message: string, attrs?: Attrs) {
    if (import.meta.env.MODE === 'test') return;
    const line = { level: level.toUpperCase(), logger: this.name, message, ...attrs };
    (level === 'debug' ? console.debug : level === 'info' ? console.info : level === 'warn' ? console.warn : console.error)(line);
  }
}
